/* eslint-disable max-classes-per-file */
import { defaults as _defaults } from 'lodash';
import { EmpType } from '../interfaces/Employee';
var TableAction;
(function (TableAction) {
    TableAction[TableAction["EditUser"] = 0] = "EditUser";
    TableAction[TableAction["SendWelcomeEmails"] = 1] = "SendWelcomeEmails";
    TableAction[TableAction["ResendWelcomeEmail"] = 2] = "ResendWelcomeEmail";
    TableAction[TableAction["TemporaryPassword"] = 3] = "TemporaryPassword";
    TableAction[TableAction["CreateTemporaryLoginURL"] = 4] = "CreateTemporaryLoginURL";
    TableAction[TableAction["MasqueradeAsUser"] = 5] = "MasqueradeAsUser";
    TableAction[TableAction["ApproverFor"] = 6] = "ApproverFor";
    TableAction[TableAction["AccountantFor"] = 7] = "AccountantFor";
})(TableAction || (TableAction = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["All"] = "All";
    AccountStatus["Active"] = "Active";
    AccountStatus["Inactive"] = "Inactive";
})(AccountStatus || (AccountStatus = {}));
var ApprovalWorkflowFilter;
(function (ApprovalWorkflowFilter) {
    ApprovalWorkflowFilter[ApprovalWorkflowFilter["MissingApprovers"] = 1] = "MissingApprovers";
    ApprovalWorkflowFilter[ApprovalWorkflowFilter["MissingAccountants"] = 2] = "MissingAccountants";
    ApprovalWorkflowFilter[ApprovalWorkflowFilter["InactiveApprovers"] = 3] = "InactiveApprovers";
    ApprovalWorkflowFilter[ApprovalWorkflowFilter["NoApprovalLimit"] = 4] = "NoApprovalLimit";
    ApprovalWorkflowFilter[ApprovalWorkflowFilter["InheritedAccountant"] = 5] = "InheritedAccountant";
    ApprovalWorkflowFilter[ApprovalWorkflowFilter["SameApprover"] = 6] = "SameApprover";
    ApprovalWorkflowFilter[ApprovalWorkflowFilter["SameAdditionalApprover"] = 7] = "SameAdditionalApprover";
})(ApprovalWorkflowFilter || (ApprovalWorkflowFilter = {}));
const defaultApprovalLimit = {
    PK: 0,
    Name: '',
    Amount: 0,
    CurrencySuffix: ''
};
const defaultManageUsersFilterParameters = {
    UserName: '',
    AccountStatus: AccountStatus.Active,
    Role: '',
    DateCreatedStart: '',
    DateCreatedEnd: '',
    UserEmail: '',
    FirstName: '',
    LastName: '',
    EmployeeID: '',
    EmailStatus: null,
    AdminLevel: '',
    ApproverPK: 0,
    ApproverEmail: '',
    AccountantPK: 0,
    AccountantEmail: '',
    Auditor: null,
    DepartmentPK: 0,
    DepartmentName: '',
    ApprLimitPK: 0,
    WelcomeEmailSent: null,
    Treasurer: null,
    Translator: null,
    AccountsPayable: null,
    EmpUDF1PK: 0,
    EmpUDF2PK: 0,
    EmpUDF3PK: 0,
    EmpUDF4PK: 0,
    EmpUDF5PK: 0
};
const defaultAddress = {
    Address: '',
    City: '',
    State: ''
};
class Address {
    Address;
    City;
    State;
    constructor(addressData) {
        _defaults(this, addressData, defaultAddress);
    }
}
const defaultACHAccount = {
    PK: null,
    ReadOnly_Flag: '',
    CustomerBankID_Masked: '',
    CustomerBankAccount_Masked: '',
    LinkID: '',
    CustomerAddress: new Address({})
};
class ACHAccount {
    PK;
    ReadOnly_Flag;
    CustomerBankID_Masked;
    CustomerBankAccount_Masked;
    LinkID;
    CustomerAddress;
    constructor(accountData) {
        _defaults(this, accountData, defaultACHAccount);
    }
}
const defaultManageUsersUserDetail = {
    UserEmail: '',
    FirstName: '',
    LastName: '',
    EmpID: '',
    EmailStatus: false,
    CommuteDistance: 0,
    CommuteUnits: false,
    AdminLevel: '',
    AccountStatus: true,
    Role: '',
    Auditor: false,
    Treasurer: false,
    Translator: false,
    AccountsPayable: false,
    DepartmentPK: 0,
    DepartmentName: '',
    DefaultCurrency: '',
    UseMultipleCurrencies: false,
    UseVAT: false,
    DefaultVATRate: 0,
    UsePST: false,
    DefaultPSTRate: 0,
    UseHST: false,
    DefaultHSTRate: 0,
    ApproverPK: 0,
    ApproverEmail: '',
    AccountantPK: 0,
    AccountantEmail: '',
    AdditionalApproverPK: 0,
    AdditionalApproverEmail: '',
    ApproverForUsersCount: 0,
    AccountantForUsersCount: 0,
    DoNotSendWelcomeEmail: false,
    ApprovalLimit: defaultApprovalLimit,
    AdministrativeNotes: '',
    DefaultSettlementAccount: null,
    PayByCheck: false,
    ACHAccount: new ACHAccount({}),
    EmpGLD1PK: 0,
    EmpGLD1Name: '',
    EmpGLD2PK: 0,
    EmpGLD2Name: '',
    EmpGLD3PK: 0,
    EmpGLD3Name: '',
    EmpGLD4PK: 0,
    EmpGLD4Name: '',
    EmpGLD5PK: 0,
    EmpGLD5Name: ''
};
class ManageUsersUserDetail {
    UserPK;
    EmpPK;
    UserEmail;
    FirstName;
    LastName;
    EmpID;
    EmailStatus;
    CommuteDistance;
    CommuteUnits;
    AdminLevel;
    AccountStatus;
    Role;
    Auditor;
    Treasurer;
    Translator;
    AccountsPayable;
    DepartmentPK;
    DepartmentName;
    DefaultCurrency;
    UseMultipleCurrencies;
    UseVAT;
    DefaultVATRate;
    UsePST;
    DefaultPSTRate;
    UseHST;
    DefaultHSTRate;
    ApproverPK;
    ApproverEmail;
    AccountantPK;
    AccountantEmail;
    AdditionalApproverPK;
    AdditionalApproverEmail;
    ApproverForUsersCount;
    AccountantForUsersCount;
    DoNotSendWelcomeEmail;
    ApprovalLimit;
    AdministrativeNotes;
    DefaultSettlementAccount;
    PayByCheck;
    ACHAccount;
    EmpGLD1PK;
    EmpGLD1Name;
    EmpGLD2PK;
    EmpGLD2Name;
    EmpGLD3PK;
    EmpGLD3Name;
    EmpGLD4PK;
    EmpGLD4Name;
    EmpGLD5PK;
    EmpGLD5Name;
    constructor(userdata) {
        _defaults(this, userdata, defaultManageUsersUserDetail);
    }
}
const emailStatuses = [
    {
        label: 'Good - Send Email',
        value: false
    },
    {
        label: 'Failed Delivery - Do Not Send',
        value: true
    }
];
const welcomeEmails = [
    {
        label: 'Welcome Email Sent',
        value: true
    },
    {
        label: 'Welcome Email Not Sent',
        value: false
    }
];
const adminLevels = ['None', 'User Administration', 'Full Administration'];
const empTypes = (useNone = false) => {
    const filtered = Object.values(EmpType).filter((val) => Number.isNaN(Number(val)) && val !== 'None' && val !== 'Guest');
    if (useNone) {
        filtered.unshift('None');
    }
    return filtered.map((item, index) => ({
        name: item,
        value: index + 1
    }));
};
export { TableAction, ApprovalWorkflowFilter, ManageUsersUserDetail, ACHAccount, defaultApprovalLimit, defaultManageUsersFilterParameters, AccountStatus, emailStatuses, welcomeEmails, adminLevels, empTypes };
